import { Currency, LenderName, Loan, MoneyDto, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { LoanConditionsGroup } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/ConditionsGroup/LoanConditionsGroup';
import { AbstractLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractLoanPaymentMethod';
import { SetupOptions } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { LoanConditions } from '@/components/modules/Application/components/PaymentMethod/_shared/types/LoanConditions';
import { PaymentMethodRequestType } from '@/components/modules/Application/components/PaymentMethod/_shared/types/PaymentMethodRequestType';

type CreditLinePaymentMethodRequest = PaymentMethodRequestType<PaymentMethodType.CREDIT_LINE>;

export class CreditLinePaymentMethod extends AbstractLoanPaymentMethod {
  protected ALLOWED_PAYMENT_METHOD_TYPES = [PaymentMethodType.CREDIT_LINE];

  public areOptionsConfigurable(): boolean {
    return false;
  }

  public setup(amount: number, currency: Currency, options?: SetupOptions): void {
    this.amount = amount;
    this.currency = currency;
    this._options = options ?? null;
    this.isSetup = true;
  }

  public seedProviderNames(lenderNames: LenderName[]): void {
    this.paymentMethodConditions = lenderNames.map((lenderName) => ({
      type: this.paymentMethodType,
      amount: new MoneyDto({ value: this.amount ?? 0, currency: this.currency }),
      currency: this.currency,
      conditions: {
        lenderName,
      },
    })) as NonNullable<typeof this.paymentMethodConditions>;
  }

  public setConditionFromLoanConditions(loan: Loan, selectedLenders?: LenderName[]): void {
    const principal = loan.loanConditions.principal;

    this.amount = principal.amount;
    this.currency = principal.currency;

    const loanPaymentMethodConditions = {
      type: this.paymentMethodType,
      amount: new MoneyDto({ value: principal.amount, currency: principal.currency }),
      currency: principal.currency,
      conditions: {
        product: loan.loanConditions.product,
        program: loan.loanConditions.program.name,
        lenderName: undefined,
      },
    };

    if (selectedLenders && selectedLenders.length > 0) {
      this.paymentMethodConditions = selectedLenders.map((lenderName) => ({
        ...loanPaymentMethodConditions,
        conditions: {
          ...loanPaymentMethodConditions.conditions,
          lenderName,
        },
      })) as NonNullable<typeof this.paymentMethodConditions>;
    } else {
      this.paymentMethodConditions = [loanPaymentMethodConditions] as NonNullable<typeof this.paymentMethodConditions>;
    }
  }

  protected setAvailableFilters(): void {
    return;
  }

  protected getAvailableConditions(allConditions: LoanConditions[]): LoanConditions[] {
    return allConditions;
  }

  protected getSelectedTermCandidate(): number {
    throw new Error('Credit line has no term');
  }

  protected getConditionsGroups(): LoanConditionsGroup[] {
    throw new Error('Credit line has no conditions groups');
  }

  protected getSelectedConditionsGroupCandidate(): LoanConditionsGroup {
    throw new Error('Credit line has no conditions groups');
  }

  public get proposedTerms(): number[] {
    return [];
  }

  public toDto(): CreditLinePaymentMethodRequest {
    return {
      type: this.paymentMethodType as CreditLinePaymentMethodRequest['type'],
    };
  }
}
